import React from "react";
import { TextField, Grid2, FormHelperText, FormControl, } from "@mui/material";
import PropTypes from "prop-types";

// Renamed props for clarity: value, onChange, label
export const NumberInputBox=({value, onChange, label, step = 1, id}) => {
    
    return (  <Grid2 item xs={12} sx={{ textAlign: 'center' }}>
        <FormControl>
        <TextField
            id={id}
            required
            type="number"
            onChange={onChange} // Use onChange prop
            // Ensure value is not null/undefined, default to empty string for controlled input
            value={value ?? ''} 
            label={label} // Use label prop for floating label
            InputLabelProps={{ shrink: true }} // Keep label floated
            inputProps={{ step: step }} // Add step prop
            sx={{ input: { textAlign: 'center' } }}
        />
            {/* Remove FormHelperText if label is used */}
            {/* <FormHelperText>
                {label}
            </FormHelperText> */}
        </FormControl>
    </Grid2>
    );

}

NumberInputBox.propTypes = {
    value: PropTypes.number, // Renamed prop
    onChange: PropTypes.func, // Renamed prop
    label: PropTypes.string, // Renamed prop
    step: PropTypes.number, 
}